module.exports = __webpack_public_path__ + "img/8ae10e4a78f748e982674e84a904d8a5.05c195dd.jpg";